module.exports = __webpack_public_path__ + "static/img/8.e7e1348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/8.png
// module id = NNBs
// module chunks = 0